import request from '@/utils/ajax';

export function queryRoleList(data){
  return request({
    url: `/wx/sys/role/select`,
    method: 'get',
  });
}

export function queryPermissionList(data){
  return request({
    url: `/wx/sys/dataPermissionTree/list`,
    method: 'get',
    params: data
  });
}

export function queryPermissionKeys(data){
  return request({
    url: `/wx/sys/dataPermissionUser/userTree`,
    method: 'get',
    params: data
  });
}

export function addUser(data){
  return request({
    url: `/wx/sys/user/save`,
    method: 'post',
    data
  });
}

export function queryUserDetail(data){
  return request({
    url: `/wx/sys/user/info/${data.userId}`,
    method: 'get',
  });
}

export function updateUser(data){
  return request({
    url: `/wx/sys/user/update`,
    method: 'post',
    data
  });
}

export function deleteUser(data){
  return request({
    url: `/wx/sys/user/delete`,
    method: 'post',
    data
  });
}
